<template>
  <SeoLandingPage :page="page" />
</template>

<script setup>
import page from "#build/page-data/solutions/contract-and-invoice-software-for-freelancers.mjs";
</script>
